var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineCheckCircle16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8C14.5 11.3137 11.8137 14 8.5 14C5.18629 14 2.5 11.3137 2.5 8C2.5 4.68629 5.18629 2 8.5 2C11.8137 2 14.5 4.68629 14.5 8Z",
    fill: "#F3FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1869 6.35355C12.3821 6.15829 12.3821 5.84171 12.1869 5.64645C11.9916 5.45118 11.675 5.45118 11.4798 5.64645L12.1869 6.35355ZM7.16665 10.6667L6.8131 11.0202C7.00836 11.2155 7.32495 11.2155 7.52021 11.0202L7.16665 10.6667ZM5.52018 8.31311C5.32492 8.11785 5.00833 8.11785 4.81307 8.31311C4.61781 8.50838 4.61781 8.82496 4.81307 9.02022L5.52018 8.31311ZM11.4798 5.64645L6.8131 10.3131L7.52021 11.0202L12.1869 6.35355L11.4798 5.64645ZM4.81307 9.02022L6.8131 11.0202L7.52021 10.3131L5.52018 8.31311L4.81307 9.02022ZM14 8C14 11.0376 11.5376 13.5 8.5 13.5V14.5C12.0899 14.5 15 11.5899 15 8H14ZM8.5 13.5C5.46243 13.5 3 11.0376 3 8H2C2 11.5899 4.91015 14.5 8.5 14.5V13.5ZM3 8C3 4.96243 5.46243 2.5 8.5 2.5V1.5C4.91015 1.5 2 4.41015 2 8H3ZM8.5 2.5C11.5376 2.5 14 4.96243 14 8H15C15 4.41015 12.0899 1.5 8.5 1.5V2.5Z",
    fill: "#185888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCheckCircle16);
export default __webpack_public_path__ + "static/media/outline-check-circle-16.cdd14aa0.svg";
export { ForwardRef as ReactComponent };